import React from "react";
// import Housefilter from "../components/housefilter"
import HousesListing from "../components/HouseList";

export const Housepage = () => {
  return (
    <div>
      <HousesListing />
    </div>
  );
};
